import { useParams, useSearchParams } from "react-router-dom";
import Release from "../release";

import "../index.less";
function Old() {
  const { type, id } = useParams();
  const [params, setParams] = useSearchParams();
  const rId = params.get("rId");
  return (
    <div className="appDetail-content">
      <Release type={type} id={id} rId={rId} />
    </div>
  );
}

export default Old;
